<section class="multi-shop-banner-wrapper">
  <div class="box-container">
    <a href="https://form.flowaccount.com/request-lazada-shopee-multi-shop" target="_blank" rel="nofollow noopener">
      <picture class="desktop-banner">
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/Banner_MultiShop_v2_{{ translate.currentLang | uppercase }}.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/Banner_MultiShop_v2_{{
            translate.currentLang | uppercase
          }}.jpg"
          class="banner-image"
          [alt]="'SHOPEE_LAZADA.MULTI_SHOP_BANNER.ALT' | translate"
          loading="lazy"
        />
      </picture>
      <picture class="mobile-banner">
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/Banner_MultiShop_mobile_v2_{{ translate.currentLang | uppercase }}.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/Banner_MultiShop_mobile_v2_{{
            translate.currentLang | uppercase
          }}.png"
          class="banner-image"
          [alt]="'SHOPEE_LAZADA.MULTI_SHOP_BANNER.ALT' | translate"
          loading="lazy"
        />
      </picture>
    </a>
  </div>
</section>
